

export function offsetFromParent(evt) {
  const rect = evt.target.getBoundingClientRect()
  return {
    x: evt.pageX - rect.x,
    y: evt.pageY - rect.y
  }
}